import useSWR from 'swr';
import { fetchPublicTopJobs, PublicTopJobsResponse } from '@services/api/public-top-jobs';


// Constants
// ********************************************
export const PUBLIC_TOP_JOBS_DEFAULT_LIMIT = 3;
const SWR_KEY = '/v2/jobs#home-public';


/**
 * @description Fetches the top public jobs for unauthenticated home visitors.
 *
 * Pass `enabled = false` (e.g. for authenticated users) to skip the fetch entirely.
 * No retries — the home slot is nice-to-have and must never block the page.
 */
export const usePublicTopJobs = (
  locale: Locale,
  enabled = true,
  limit = PUBLIC_TOP_JOBS_DEFAULT_LIMIT,
) => {
  const { data, isLoading } = useSWR<PublicTopJobsResponse>(
    enabled ? [SWR_KEY, locale, limit] : null,
    () => fetchPublicTopJobs(limit, locale),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      errorRetryCount: 0,
    },
  );

  const items = data?.items ?? [];

  return {
    items,
    isLoading: enabled && isLoading,
    hasItems: items.length > 0,
  };
};
